import React from 'react';

interface Props {
  children?: React.ReactNode;
  className?: string;
  label: string;
  vertical?: boolean;
}

export default function Section({ children, className = '', label, vertical }: Props) {
  const flexClasses = vertical
    ? 'flex-column'
    : 'flex-row justify-content-between align-items-center';
  return (
    <div className={`d-flex ${flexClasses} mb-4 ${className}`}>
      <h3 className={vertical ? 'mt-0' : 'm-0'}>{label}</h3>
      {children}
    </div>
  );
}
